import { useTranslation } from "react-i18next";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import "bootstrap/dist/css/bootstrap.min.css";

const TajikistanEconomicStats = () => {
  const { t } = useTranslation();
  const { width } = 0;
  const isSmallScreen = width < 576;

  const foreignInvestmentData = [
    { year: "2022", value: 2576.8, label: "2576.8 M" },
    { year: "2023", value: 2690.4, label: "2690.4 M" },
    { year: "2024", value: 4900.0, label: "4900.0 M" },
    { year: "2025", value: 6925.0, label: "6925.0 M" },
  ];

  const externalTradeData = [
    { year: "2022", value: 7512.9, label: "7512.9 M" },
    { year: "2023", value: 8328.9, label: "8328.9 M" },
    { year: "2024", value: 8950.0, label: "8950.0 M" },
    { year: "2025", value: 9700.0, label: "9700.0 M" },
  ];

  const gdpData = [
    { year: "2022", value: 11300.0, label: "11300.0 M" },
    { year: "2023", value: 12100.0, label: "12100.0 M" },
    { year: "2024", value: 14160.0, label: "14160.0 M" },
    { year: "2025", value: 19000.0, label: "19000.0 M" },
  ];

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-white p-2 border rounded shadow-sm">
          <p className="mb-0 small">{`${payload[0].value} ${t(
            "millionDollars",
          )}`}</p>
        </div>
      );
    }
    return null;
  };

  const ChartWithTitle = ({ title, data }) => (
    <div className="col-12 col-md-6 col-lg-4 mb-4 mb-lg-0">
      <div className="text-center mb-3">
        <h5 className="fw-bold h6 h5-md h4-lg">{title}</h5>
        <p className="text-muted small">({t("millionDollars")})</p>
      </div>
      <div style={{ width: "100%", height: "280px", minHeight: "250px" }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={data}
            margin={{
              top: 20,
              right: isSmallScreen ? 5 : 10,
              left: isSmallScreen ? 5 : 10,
              bottom: 5,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" vertical={false} />
            <XAxis
              dataKey="year"
              fontSize={isSmallScreen ? 11 : 12}
              interval={0}
            />
            <YAxis
              domain={[0, "dataMax + 1000"]}
              tickCount={6}
              tickFormatter={(value) => value.toLocaleString()}
              fontSize={isSmallScreen ? 10 : 11}
              width={isSmallScreen ? 45 : 55}
            />
            <Tooltip content={<CustomTooltip />} />
            <Bar
              dataKey="value"
              fill="rgb(28, 82, 82)"
              radius={[4, 4, 0, 0]}
              label={{
                position: "top",
                fill: "rgb(28, 82, 82)",
                fontSize: isSmallScreen ? 10 : 12,
                formatter: (value) =>
                  isSmallScreen ? `${value}M` : `${value} M`,
              }}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );

  return (
    <div className="container py-4 py-md-5">
      <div className="row g-3 g-md-4">
        <ChartWithTitle
          title={t("charts.foreignInvestment")}
          data={foreignInvestmentData}
        />
        <ChartWithTitle
          title={t("charts.externalTrade")}
          data={externalTradeData}
        />
        <ChartWithTitle title={t("charts.gdp")} data={gdpData} />
      </div>
    </div>
  );
};

export default TajikistanEconomicStats;
